module.exports = __webpack_public_path__ + "img/p_2.48dd8cfe.png";